import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-0fdb6e43"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = /*#__PURE__*/_createTextVNode("热力图");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_button = _resolveComponent("el-button");

  return _openBlock(), _createBlock(_component_el_button, {
    type: "primary",
    color: "#F5000C",
    onClick: $setup.routerLink
  }, {
    default: _withCtx(function () {
      return [_hoisted_1];
    }),
    _: 1
  }, 8, ["onClick"]);
}